import styled from '@emotion/styled';
import { Architect, BlueFlame, Camera, Guard } from '@innovamat/glimmer-assets';
import { Modal, Typography } from '@innovamat/glimmer-components';
import { useTranslation } from 'react-i18next';
import { useCurrentNavigationValues } from '../contents';

type Props = {
  blurCount: number;
  isOpen: boolean;
  onClose: () => void;
};

const ModalContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const MissingFocusModal = ({
  blurCount,
  isOpen,
  onClose,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const { currentClassroom } = useCurrentNavigationValues();

  const isSecondGroup =
    currentClassroom?.courseOrder === 14 ||
    currentClassroom?.courseOrder === 15;

  const missingFocusConfigByCount = {
    1: {
      Image: isSecondGroup ? Camera : BlueFlame,
      title: t('secondaryPractice.warningActivityEscape.title1'),
      buttonText: t('secondaryPractice.warningActivityEscape.button1'),
      body: t('secondaryPractice.warningActivityEscape.body1'),
    },
    2: {
      Image: isSecondGroup ? Guard : Architect,
      title: t('secondaryPractice.warningActivityEscape.title2'),
      buttonText: t('secondaryPractice.warningActivityEscape.button2'),
      body: t('secondaryPractice.warningActivityEscape.body2'),
    },
  };

  const currentConfig =
    missingFocusConfigByCount[
      blurCount as keyof typeof missingFocusConfigByCount
    ] ?? missingFocusConfigByCount[2];

  const handleSubmit = (): void => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      Image={currentConfig.Image}
      semantic={{ type: 'warning', text: t('common.modal.important') }}
      title={currentConfig.title}
      closeButton="inner"
      buttons={[
        {
          variant: 'accent',
          onClick: handleSubmit,
          children: currentConfig.buttonText,
        },
      ]}
      modalWidth={700}
      onClose={onClose}
      onSubmit={handleSubmit}
    >
      <ModalContent>
        <Typography.Body1>{currentConfig.body}</Typography.Body1>
      </ModalContent>
    </Modal>
  );
};

export default MissingFocusModal;
